import { CustomerErrorDetailsDtoCodeEnum, CustomerFlagDto, CustomerItemDto } from '@/api/generated';
import {
  CustomerStatusOptionsTranslation,
  customerStatusOptionsTranslation,
  CustomerTypeOptionsTranslation,
  customerTypeOptionsTranslation,
  flagOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';
import { CustomerSearchFormModel } from '@/views/customers/list/model/CustomersSearchForm.model.ts';

export type CustomersViewTranslation = {
  header: {
    button: {
      add: string;
      pendingProspects: string;
    };
    menu: CustomerTypeOptionsTranslation;
  };
  status: {
    errors: Record<CustomerErrorDetailsDtoCodeEnum, string> & {
      forbidden: string;
    };
    formField: {
      lockedHint: string;
    };
    processPicker: {
      inactive: string;
      requiresApproval: string;
      selectedCustomerNotApproved: string;
    };
  };
  table: {
    body: Record<keyof Omit<CustomerItemDto, 'customerId'>, Record<string, string> | string> & {
      flagOption: Record<CustomerFlagDto, string>;
      selectCustomer: string;
      selectCustomerBlocked: string;
      statusOption: CustomerStatusOptionsTranslation;
      typeOption: CustomerTypeOptionsTranslation;
    };
    head: Record<keyof CustomerSearchFormModel, string>;
  };
};

export const customersViewTranslation: CustomersViewTranslation = {
  header: {
    button: {
      add: 'Dodaj klienta',
      pendingProspects: 'Do akceptacji ({{count}})',
    },
    menu: customerTypeOptionsTranslation,
  },
  status: {
    errors: {
      [CustomerErrorDetailsDtoCodeEnum.CustomerApproveRequired]:
        'Od razu aktywnego klienta może utworzyć tylko osoba z uprawnieniem do zatwierdzania klientów.',
      [CustomerErrorDetailsDtoCodeEnum.CustomerInitialStatusNotAllowed]:
        'Nowy klient może mieć tylko status Prospekt albo Aktywny.',
      [CustomerErrorDetailsDtoCodeEnum.CustomerNotApproved]:
        'Klient wymaga zatwierdzenia. Klientem procesu może zostać tylko aktywny, zatwierdzony klient.',
      [CustomerErrorDetailsDtoCodeEnum.CustomerNotFound]: 'Klient nie istnieje.',
      [CustomerErrorDetailsDtoCodeEnum.CustomerNotProspect]:
        'Klient nie czeka już na tę decyzję, ktoś podjął ją wcześniej. Odświeżono dane klienta.',
      [CustomerErrorDetailsDtoCodeEnum.CustomerNotRejected]:
        'Klient nie jest już odrzucony. Odświeżono dane klienta.',
      [CustomerErrorDetailsDtoCodeEnum.CustomerRejectionReasonRequired]: 'Podaj powód odrzucenia.',
      [CustomerErrorDetailsDtoCodeEnum.CustomerRejectionReasonTooLong]:
        'Powód odrzucenia może mieć najwyżej 2000 znaków.',
      [CustomerErrorDetailsDtoCodeEnum.CustomerStatusChangeNotAllowed]:
        'Status Prospekta i Odrzuconego klienta zmienia tylko decyzja o zatwierdzeniu, nie edycja.',
      forbidden: 'Nie masz uprawnienia do tej operacji.',
    },
    formField: {
      lockedHint:
        'Status Prospekta i Odrzuconego klienta zmienia tylko decyzja w szczegółach klienta.',
    },
    processPicker: {
      inactive: 'Klient nieaktywny',
      requiresApproval: 'Wymaga zatwierdzenia',
      selectedCustomerNotApproved:
        'Klient wymaga zatwierdzenia. Klientem procesu może zostać tylko aktywny, zatwierdzony klient.',
    },
  },
  table: {
    body: {
      address: 'Adres',
      distinguishingLabel: 'Wyróżnik',
      flag: 'Flaga',
      flagOption: flagOptionsTranslation,
      name: 'Nazwa',
      nip: 'NIP',
      selectCustomer: 'Wybierz klienta',
      selectCustomerBlocked: 'Nie można wybrać klienta: {{reason}}',
      status: 'Status',
      statusOption: customerStatusOptionsTranslation,
      type: 'Typ',
      typeOption: customerTypeOptionsTranslation,
    },
    head: {
      fullTextSearchInput: 'Szukaj',
      ownerIdOfCustomerContact: 'Opiekun kontaktu',
      statuses: 'Status',
    },
  },
};
